var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 0C4.74306 0 2.5 2.24306 2.5 5.00001C2.5 5.82765 2.70692 6.64825 3.10029 7.3761L7.22658 14.8389C7.28151 14.9384 7.38619 15 7.50001 15C7.61383 15 7.71851 14.9384 7.77344 14.8389L11.9012 7.37364C12.2931 6.64825 12.5 5.82762 12.5 4.99998C12.5 2.24306 10.257 0 7.50001 0ZM7.50001 7.5C6.12153 7.5 5.00002 6.37849 5.00002 5.00001C5.00002 3.62153 6.12153 2.50002 7.50001 2.50002C8.87849 2.50002 10 3.62153 10 5.00001C10 6.37849 8.87849 7.5 7.50001 7.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8a1cf0cb6fbc6cf90c718d4a9aa49cb4.svg";
export { ForwardRef as ReactComponent };